import { useEventBus as _useEventBus } from '@vueuse/core';

// SSR-safe wrapper for VueUse's useEventBus.
//
// VueUse stores all event bus listeners in a module-level Map.
// During SSR, each .on() call adds a handler whose closure captures the
// per-request component instance and nuxtApp context (including large
// icon collections and API data). These listeners accumulate across
// requests and prevent garbage collection, causing memory leaks.
//
// Event buses are purely for client-side UI coordination (scroll events,
// drawer adjustments, navigation refreshes, etc.) and are never needed
// during server rendering.

const ssrStub = {
  on() { return () => {}; },
  once() { return () => {}; },
  off() {},
  emit() {},
  reset() {}
};

export function useEventBus(key) {
  if (process.server) {
    return ssrStub;
  }

  return _useEventBus(key);
}
